declare namespace $ {

	export class $rise_drag extends $mol_plugin {
		pointerdown( next?: any ): any
		dragged( next?: boolean ): boolean
		pointermove_listener( ): $mol_dom_listener | null
		pointerup_listener( ): $mol_dom_listener | null
		x( next?: number ): number
		y( next?: number ): number
		repos_x( id: any): number
		repos_y( id: any): number
		on_drag( next?: any ): any
		on_drag_start( next?: any ): any
		on_drag_end( next?: any ): any
		drag( next?: any ): any
		drag_start( next?: any ): any
		drag_end( next?: any ): any
		use_buttons( ): readonly(any)[]
		event( ): ({ 
			pointerdown( next?: ReturnType< $rise_drag['pointerdown'] > ): ReturnType< $rise_drag['pointerdown'] >,
		})  & ReturnType< $mol_plugin['event'] >
		attr( ): ({ 
			'rise_dragged': ReturnType< $rise_drag['dragged'] >,
		})  & ReturnType< $mol_plugin['attr'] >
		auto( ): readonly(any)[]
		drags_synced( ): readonly($rise_drag)[]
	}
	
}

//# sourceMappingURL=drag.view.tree.d.ts.map